import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
//import { fetchPosts } from '../actions/postsActions';
//import { Post } from '../components/Post';
import { Progress } from '@mantine/core';
import { useSelector } from 'react-redux';
import { FooterSimple } from '../components/FooterSimple';
import { MobileSimpleHeader } from '../components/MobileSimpleHeader';

import { FileUploadWPreviewCard } from '../components/FileUploadWPreviewCard';
import { PhotoGallery } from '../components/PhotoGallery';
import { StepperBaseCard } from '../components/StepperBaseCard';
import { CarCreationCardA } from '../components/CarCreationCardA';
import { CarCreationCardB } from '../components/CarCreationCardB';
import { PhotoGalleryB } from '../components/PhotoGalleryB';

import { CarCreationContain } from '../components/CarCreationContain';
//import { TheAccordianCard } from '../components/AccordianCard';
import { InventoryList } from '../components/InventoryList';
import ConfirmationCardBase from '../components/ConfirmationCardBase';
import { DashboardGrid } from '../components/DashboardGrid';
import DynamicCompContain from '../components/DynamicCompContain';

//add a progress bar at the top
import skull_640 from '../assets/skull_640.png';
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
import pagani from '../assets/pagani.jpg';

//this needs params
const AuctionItemMgmtCustomLayouts = () => {
    const photos = [
        {
            src: black_and_white_mercedes_benz,
            width: 1,
            height: 1,
        },
        {
            src: pagani,
            width: 2,
            height: 1,
        },
        {
            src: skull_640,
            width: 1,
            height: 1,
        }
    ];
    
    const componentMapping = {
        CarCreationCardA,
        CarCreationCardB,
        InventoryList,
        CarCreationContain,
        ConfirmationCardBase
    };
    
    const layoutA = [
        {
            componentName: 'CarCreationCardA',
            render: false,//whether or not the item should be rendered
            props: { }
        },
        {
            componentName: 'ConfirmationCardBase',
            render: false,
            props: {
                message: "confirm you are dynamically rendering the modules"
            }
        },
        
    ];

    const layoutB = [
        {
            componentName: 'CarCreationCardB',
            render: true,//whether or not the item should be rendered
            props: { }
        },
        {
            componentName: 'InventoryList',
            render: true,//whether or not the item should be rendered
            props: { }
        },
    ];
    
    //needs to be its own function
    const Website = ({ config }) => {
        return (
            <>
                {config.map(({ componentName, render, props }) => {
                    if (render){
                        const Component = componentMapping[componentName];
                        return <Component key={nanoid()} {...props} />;
                    }
            })}
            </>
        );
    };
    
    return (
        <>
            <MobileSimpleHeader 
                avatar={pagani}
                drawSubSectMenu={false}
            />
            {/*have a switch case for assignment of the sub menu*/}
            <br/>
            <br/>
            <br/>
            {/*<Website config={layoutA}/>*/}
            <Website config={layoutA}/>
            <br/>
            <br/>
            <DashboardGrid />
            {/*SCROLL AREA... or just use the stats card from CarCardDets
            <InventoryList />*/}
            <br/>
            <br/>
            <br/>
            <br/>
            {/*<FooterSimple />*/}
        </>
    )

}

export default AuctionItemMgmtCustomLayouts
/*
 * 
 * - Add Simple footer back in
    - Aucitoneer Footer is needed

Clicks needed on inventory list homepage
- add_item - > CarCreationContain.js -> (request new listing id)
- inventory_radio_change -> change inventory list
- item_staff: edit staff for that specific listing
- item_edit: -> AuctionListEdit
- item_schedule: -> scheduler for auctioneer ctx
- confirmation: after a scheduler time-slot is selected
- attach dispatchers, selectors, and ajax requesters(async thunk)
- define the data_struct for the auction module


GENERAL VIEWS NEEDED:
- list of staff (use inventoryList as base)
- list of subscribers (use inventoryList as base)
- event_card
- event_creation card
- item's assigned staff members(for editing)
- full calendar view
- alerts(start with comment card)
- messaging(contextual)
- account settings (divide by stacks (ones for buyers and auctioneers))
- mysite(auctioneer only)

 * 
 * 
 * */
